import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.updateLocale('en', {
    weekStart: 1
});

export default class DataFormatterService {
    stringToTimeRange(time, timeZone = 'America/New_York', return_raw = false, return_date_object = false) {
        const date_range = { start: '', end: '' };
        let return_data = {};

        switch (time) {
            case 'current_month':
                date_range.start = dayjs().tz(timeZone).startOf('month');
                date_range.end = dayjs().tz(timeZone).endOf('month');
                break;

            case 'last_month':
                date_range.start = dayjs().tz(timeZone).subtract(1, 'month').startOf('month');
                date_range.end = dayjs().tz(timeZone).subtract(1, 'month').endOf('month');
                break;

            case 'yesterday':
                date_range.start = dayjs().tz(timeZone).subtract(1, 'day').startOf('day');
                date_range.end = dayjs().tz(timeZone).subtract(1, 'day').endOf('day');
                break;

            case 'last_week':
                date_range.start = dayjs().tz(timeZone).subtract(1, 'week').startOf('week');
                date_range.end = dayjs().tz(timeZone).subtract(1, 'week').endOf('week');
                break;

            case 'current_week':
                date_range.start = dayjs().tz(timeZone).startOf('week');
                date_range.end = dayjs().tz(timeZone).endOf('week');
                break;

            case 'today':
                date_range.start = dayjs().tz(timeZone).startOf('day');
                date_range.end = dayjs().tz(timeZone).endOf('day');
                break;

            case 'this_year':
                date_range.start = dayjs().tz(timeZone).startOf('year');
                date_range.end = dayjs().tz(timeZone).endOf('year');
                break;

            case 'last_year':
                date_range.start = dayjs().tz(timeZone).subtract(1, 'year').startOf('year');
                date_range.end = dayjs().tz(timeZone).subtract(1, 'year').endOf('year');
                break;

            default:
                //start from 2023
                date_range.start = dayjs('2023-01-01');
                date_range.end = dayjs().tz(timeZone);
        }

        return_data = {
            reportStart: date_range.start.format('MMM D, YYYY HH:mm'),
            reportEnd: date_range.end.format('MMM D, YYYY HH:mm')
        };

        if (return_date_object) {
            return [new Date(date_range.start.format('YYYY-MM-DDTHH:mm:ss.SSS')), new Date(date_range.end.format('YYYY-MM-DDTHH:mm:ss.SSS'))];
        }

        if (!return_raw) {
            return return_data;
        }

        return return_data.reportStart + ' - ' + return_data.reportEnd;
    }
    getFormattedDateTimeRange(date, time, raw = false) {
        if (date.length !== 0 && Object.keys(time).length !== 0) {
            const start_date = dayjs(date[0]).format('MMM D, YYYY');
            const end_date = dayjs(date[1]).format('MMM D, YYYY');
            const start_time = dayjs(time.start).format('HH:mm');
            const end_time = dayjs(time.end).format('HH:mm');

            if (raw) {
                return {
                    reportStart: `${start_date} ${start_time}`,
                    reportEnd: `${end_date} ${end_time}`
                };
            }

            return `${start_date} ${start_time} - ${end_date} ${end_time}`;
        }

        return '';
    }
    getFormattedDateRange(date, raw = false) {
        if (Object.keys(date).length > 1 && date.start && date.end) {
            const start_date = dayjs(date.start).startOf('day').format('MMM D, YYYY HH:mm');
            const end_date = dayjs(date.end).endOf('day').format('MMM D, YYYY HH:mm');

            if (raw) {
                return {
                    reportStart: `${start_date}`,
                    reportEnd: `${end_date}`
                };
            }

            return `${start_date} - ${end_date}`;
        }

        return '';
    }
    isDateBiggest(date, times) {
        const start = dayjs(times.start).format('HH:mm').replace(':', '');
        const end = dayjs(times.end).format('HH:mm').replace(':', '');

        const start_date = dayjs(date[0]).format('YYYYMMDD');
        const end_date = dayjs(date[1]).format('YYYYMMDD');

        //if date is same day and start time is bigger than end time
        return start_date === end_date && start > end;
    }
    formatNumber(value, fixedPoints = null) {
        if (fixedPoints === null) {
            return value.toLocaleString('en-US');
        }
        return value.toFixed(fixedPoints).toLocaleString('en-US');
    }
    formatCurrency(value) {
        return Number(value)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            .toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
    convertTimezone(dateTime, toTz) {
        if (typeof dateTime === 'undefined' || dateTime === null || dateTime === '') {
            return dateTime;
        }
        return dayjs.tz(dateTime, 'Europe/Berlin').tz(toTz).format('MMM D, YYYY HH:mm:ss');
    }
    formatDateTime(dateTime, format = 'MMM D, YYYY HH:mm:ss', toTz) {
        if (typeof dateTime === 'undefined' || dateTime === null || dateTime === '') {
            return dateTime;
        }
        return dayjs.tz(dateTime, 'Europe/Berlin').tz(toTz).format(format);
    }
    calculateAcceptanceRate(accepted, callsAndLeads, fixedPoints = 1) {
        const formatNum = this.formatNumber((accepted / callsAndLeads) * 100, 2);
        return formatNum == 'NaN' ? 0 : parseFloat(formatNum).toFixed(fixedPoints);
    }
}
